import { render, staticRenderFns } from "./AddCustomerDialog.vue?vue&type=template&id=8302df8e"
import script from "./AddCustomerDialog.vue?vue&type=script&lang=js"
export * from "./AddCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports